import { Component, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomerDataService } from '../services/customer-data.service';
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { interval, Subscription } from 'rxjs';
import { RestService } from '../services/rest.service';
//import { getAuth, signOut } from "firebase/auth";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm!: UntypedFormGroup
  error!: string;
  nan!: Subscription;

  baseUrl = this.rest.apiPath;
  constructor(private service: CustomerDataService, private router: Router, private rest: RestService) { }

  ngOnInit(): void {

    this.loginForm = new UntypedFormGroup({
      email: new UntypedFormControl('', Validators.email),
      password: new UntypedFormControl('')
    });

    // this.service.isLoggedIn.subscribe((res) => {
    //   this.hi()
    // })

    // this.statusInterval.subscribe(() => {
    //   // this.service.hello().subscribe((res) => {
    //   //   this.service.loging(res.token)
    //   // })
    //   // this.service.hello().subscribe((res) => {
    //   //   if (res.token) {
    //   //     const token = res.token
    //   //     const auth = getAuth();
    //   //     signInWithCustomToken(auth, token)
    //   //       .then((userCredential) => {
    //   //         // Signed in
    //   //         //  const user = userCredential.user;
    //   //         console.log(userCredential)
    //   //         // ...
    //   //       }).catch((error) => {
    //   //         const errorCode = error.code;
    //   //         const errorMessage = error.message;
    //   //         // ...
    //   //       });
    //   //     this.service.loging(res.token)
    //   //     // this.router.navigate(['/customers']);
    //   //   } else {
    //   //     console.log('no one')
    //   //   }
    //   // })
    // })


  }

  get f() { return this.loginForm.controls; }


  // login(data:any) {
  //   if (this.loginForm.valid) {
  //     this.service.loginform(data);
  //   }
  //  }

  login(data: any) {
    /* if (this.loginForm.valid) {
      this.service.loginform({
        email: data.email,
        password: data.password
      }
      ).subscribe((res: any) => {
        console.log(res)
        const data = res.token
        const auth = getAuth();
        signInWithCustomToken(auth, data)
          .then((userCredential) => {
            // Signed in
            //  const user = userCredential.user;
            console.log(userCredential)
            // ...
          }).catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            // ...
          });

        // this.service.hello().subscribe((res: any) => { this.service.loging(res.token) })
        this.service.loging(data);
        this.loginForm.reset();
        this.router.navigate(['/customers']);
      }, (errorMessage) => {
        console.log(errorMessage)
        this.error = errorMessage;
      })

    } */
  }


}
